import request from '../utils/request';
import {getToken,getRefresh} from '../utils/auth'

export function login(data) {
    return request({
        url:'/api/auth/token/login/',
        method:'post',
        data
    });
}

export function refreshToken() {
    return request({
        url:'/api/auth/token/refresh/',
        headers:{
            'Content-Type': 'application/json'                  
            },
        method:'post',
        data:{refresh:getRefresh()}
    })
}

export function logOutUser() {
    return request({
        url:'/api/auth/blacklist/logout/',
        method:'post',
        headers:{
            'Content-Type': 'application/json'                  
            },
        data:{refresh:getRefresh()}
    })
}

export function getAuthUserData() {
    return request({
        url:'/api/auth/user',
        method:'get'
    })
}

export function getUserAuth() {
    return request({
        url:'/api/auth/get-user/',
        method:'get'
    })
}